module.exports = __webpack_public_path__ + "cert-step.262bda25821fe5991e01f7bbdb62dfce.hashedasset.png";


//////////////////
// WEBPACK FOOTER
// ./app/img/layout/cert-step.png
// module id = 7713158124387301
// module chunks = 1